import { UniDriver } from '@wix/unidriver-core';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';

export const modalMobileLayoutDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),

    /**
     * Gets the title node
     * @return {UniDriver}
     */
    title: base.$('[data-hook="modalMobileLayout-title"]'),
    /**
     * @deprecated use title
     * @return {Promise<UniDriver>}
     */
    getTitle: async () => base.$('[data-hook="modalMobileLayout-title"]'),
    /**
     * Gets the content node
     * @return {UniDriver}
     */
    content: base.$('[data-hook="modalMobileLayout-content"]'),

    /**
     * Gets the content node
     * @deprecated use content
     * @return {Promise<UniDriver>}
     */
    getContent: async () => base.$('[data-hook="modalMobileLayout-content"]'),

    /**
     * Gets the footer node
     * @deprecated use footer
     * @return {Promise<UniDriver>} Footer testkit
     */
    getFooter: async () => base.$('[data-hook="modalMobileLayout-footer"]'),

    /**
     * Gets the footer node
     * @return {UniDriver} Footer testkit
     */
    footer: base.$('[data-hook="modalMobileLayout-footer"]'),
    /**
     * Clicks on the overlay
     * @return {Promise<void>}
     */
    clickOverlay: async () => base.click(),

    /**
     * Clicks on the close button
     * @return {Promise<void>}
     */
    clickCloseButton: async () =>
      base.$('[data-hook="modalMobileLayout-close-button"]').click(),

    /**
     * Checks whether close button exist
     * @return {Promise<boolean>}
     */
    closeButtonExists: async () =>
      base.$('[data-hook="modalMobileLayout-close-button"]').exists(),
  };
};

export type ModalMobileLayoutUniDriver = ReturnType<
  typeof modalMobileLayoutDriverFactory
>;
